export const START_LOADING = "START_LOADING";
export const END_LOADING = "END_LOADING";
export const START_SEEDING_FARM_DATA = "START_SEEDING_FARM_DATA";
export const END_SEEDING_FARM_DATA = "END_SEEDING_FARM_DATA";
